<div class="{uiClasses}segment" part="segment">
  {>slot}
</div>
